import APIRequest from "./APIRequest";

export const createIntent = (params) => {
  return APIRequest.post(`user/create-setup-intent`, {...params,stopLoading:true});
};

export const paymentSuccess = (params) => {
  return APIRequest.post(`user/subscribe`, {...params,stopLoading:true});
};
export const getAllPaymentMethods = (params) => {
  return APIRequest.get(`user/get-all-payment-methods`, params);
};
export const addUpdateDefaultCard = (params) => {
  return APIRequest.post(`user/update-payment-method`, params);
};
export const cancelSubscription  = (params) => {
  return APIRequest.post(`user/cancel-subscription/${params?.id}`, params);
};
export const renewSubscription  = (params) => {
  return APIRequest.post(`user/resume-subscription/${params?.id}`, params);
};
export const getPlans = (params) => {
  return APIRequest.get(`web/plans`, params);
};